import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { Deserializable } from '../deserializable';
import { Role } from './role.model';

export class Staff implements Deserializable {
  public StaffIdAsHash: string;
  public Permissions: Array<string>;
  public TeamName: string;
  public StaffID: number;
  public SocietyID?: number;
  public FirstName: string;
  public LastName: string;
  public UserName: string;
  public Email: string;
  public TeamCode: string;
  public TimeLoggedOut?: Date;
  public AccessTokenGuid?: string;
  public OneTimeTokenGuid?: string;
  public IsAuthenticated: boolean;
  public Roles: Array<Role>;
  public get CompanyName(): string {
    return ReferenceDataLabels.InternalCompanyName;
  }
  public get FullName(): string {
    return `${this.FirstName} ${this.LastName}`;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    this.Permissions = input.Permissions;
    this.Roles = input.Roles;

    return this;
  }
}
